import React from 'react';
import PropTypes from 'prop-types';

import DebuggableComponent from '../utils/debuggable-component';
import i18next from 'i18next';

import SeatElements from './seat-elements';

import SeatMap from './seat-map';
import SeatPopover from './seat-popover';
import Minimap from './minimap';
import {Zoomable} from '../utils/zoomable';

export default class SeatMapContainer extends DebuggableComponent {
    constructor() {
        super(...arguments);
        // No need to trigger updates to state
        this.seatOver = null;

        // Let's break prototyping in JS because react cannot compare functions
        this.onSeatOver = this.onSeatOver.bind(this);

        let seatElementsProp =
      this.props.seatElements || this.props.mapOptions.seatElements || {};
        this.state = {
            seatElements: { ...SeatElements, ...seatElementsProp },
        };
    }

    onSeatOver(seat, extra) {
        if (!this.state.seatOver || !seat || seat.pk !== this.state.seatOver.pk) {
            this.setState({
                seatOver: seat,
            });
        }

        this.props.onSeatOver(seat, extra);
    }

    renderContent() {
        let {
            showPopup,
            getLabel,
            minimap,
            sceneLabel,
            zone,
            showScene,
            mapOptions = {},
            ...rest
        } = this.props;
        let sceneTranslation = !sceneLabel ? i18next.t('scene') : sceneLabel;

        let mapProps = { ...mapOptions, ...rest, onSeatOver: this.onSeatOver};

        // Auto-add state to each seat missing it
        zone.seats.forEach((seat) => {
            seat.state = seat.state || (seat.booking_state || '').toLowerCase();
        });

        mapProps.seatElements = this.state.seatElements;

        // Zooming conflicts with the minimap and makes "click and drag" a panning move,
        // so it is incompatible with draggable
        const canZoom= this.props.zoomControls && !this.props.minimap && !this.props.draggable;

        const seats = <>
            {showScene && zone.scene_location === 'UP' && (
                <div className="seatmap-scene-label">{sceneTranslation}</div>
            )}
            <SeatMap zone={zone} {...mapProps} />
            {showScene && zone.scene_location === 'DOWN' && (
                <div className="seatmap-scene-label">{sceneTranslation}</div>
            )}
        </>;

        return (
            <React.Fragment>
                {canZoom ? <Zoomable>{seats}</Zoomable>:seats}
                {minimap&& <Minimap forMap={this.props.name} zone={this.props.zone} />}
                {showPopup && (
                    <SeatPopover
                        seat={this.state.seatOver}
                        getLabel={getLabel}
                        popover={this.props.popover}
                    />
                )}
            </React.Fragment>
        );
    }
}

SeatMapContainer.Map = SeatMap;

SeatMapContainer.defaultProps = {
    showPopup: true,
    defaultColor: '#0f32fa',
    getLabel: undefined,
    onSeatOver: () => {},
    popover: null,
    minimap: false,
    name: `seatmap-${Math.floor(Math.random() * 0x1000000)}`,
    sceneLabel: null,
    showScene: false,
    locale: 'en-GB',
};

SeatMapContainer.propTypes = {
    showScene: PropTypes.bool,
    sceneLabel: PropTypes.string,
    categories: PropTypes.array.isRequired,
    zone: PropTypes.object.isRequired,
    showPopup: PropTypes.bool,
    getLabel: PropTypes.func,
    mapOptions: PropTypes.shape(SeatMap.optionsTypes),
    onSeatClicked: PropTypes.func,
    onSeatsSelected: PropTypes.func,
    onSeatOver: PropTypes.func,
    popover: PropTypes.any,
    minimap: PropTypes.bool,
    defaultColor: PropTypes.string,
    name: PropTypes.string,
    locale: PropTypes.string,
};
